import { render, staticRenderFns } from "./tabFrame.vue?vue&type=template&id=d723edf6"
import script from "./tabFrame.vue?vue&type=script&lang=js"
export * from "./tabFrame.vue?vue&type=script&lang=js"
import style0 from "./tabFrame.vue?vue&type=style&index=0&id=d723edf6&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports